export default __webpack_public_path__ + "static/media/11.0018f2d8.jpg";